import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';

const Switch = (props) => {
  const { isEnabled, onChange, wrapperStyle, } = props;
  const styles = useStyles({ isEnabled, wrapperStyle, });

  return (
    <div className={styles.wrapper} onClick={() => onChange(!isEnabled)}>
      <span className={styles.circle}></span>
    </div>
  );
}

const useStyles = createUseStyles({
  wrapper: (props) => ({
    width: 53,
    height: 27,
    display: 'flex',
    alignItems: 'center',
    padding: 1,
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: props.isEnabled ? '#57c2ef' : '#d0ccd3',
    borderRadius: 27,
    ...props.wrapperStyle,
  }),
  circle: (props) => ({
    left: props.isEnabled ? 1 : 27,
    width: 25,
    height: 25,
    position: 'absolute',
    backgroundColor: '#ffffff',
    borderRadius: 25,
  }),
});

Switch.propTypes = {
  onChange: PropTypes.func.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  wrapperStyle: PropTypes.object,
}

Switch.defaultProps = {
  wrapperStyle: {},
}

export default Switch;
